/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity, enumeration } from '@gh/core-data';
import { CloneUsingPriceBookType, SystemVarsSalesDto } from './system-vars-sales.dto';

export const SystemVarsSalesMapper = entity<SystemVarsSalesDto>({
  rfqClone: enumeration(CloneUsingPriceBookType),
});
